/**
 * XML 1.0 illegal control characters (excludes tab/LF/CR, which are valid).
 * Blocks the PDF-paste control characters that trigger ORA-64464 on save.
 * Single source of truth shared by the global Formly override (app.module.ts)
 * and the nested address modal form (form-selector.component.ts).
 */
export const XML_ILLEGAL_CHARS = /[\x00-\x08\x0B\x0C\x0E-\x1F\uFFFE\uFFFF]/;

export const CONTROL_CHARS_VALIDATOR = {
  controlChars: {
    expression: (c: { value: unknown }) => !c.value || !XML_ILLEGAL_CHARS.test(c.value as string),
    message: 'This field contains unsupported characters. Please retype your entry or paste as plain text.',
  },
};

const CONTROL_CHARS_MESSAGE =
  'This field contains unsupported characters. Please retype your entry or paste as plain text.';

/**
 * fin-form (finra-forms) schema-driven layout expects a field's `validators` to be
 * an ARRAY of { name, validation, message } entries — not the Formly object map
 * used by the global type override. Use this shape when wiring validators directly
 * on layout fields inside a nested fin-form (e.g. the address modal).
 */
export const CONTROL_CHARS_LAYOUT_VALIDATORS = [
  {
    name: 'controlChars',
    validation: (control: { value: unknown }) => !control.value || !XML_ILLEGAL_CHARS.test(control.value as string),
    message: () => CONTROL_CHARS_MESSAGE,
  },
];
